/**
 * dp-product-section.js
 * Handles:
 *  1. Image slider (prev/next/dots/thumbs/swipe)
 *  2. Variant picker — updates price, availability, SKU, image
 *  3. Quantity stepper
 *  4. Add to Cart — opens cart drawer or updates count
 *  5. Share copy-link button
 *  6. Shopify section:load re-init for theme editor
 *
 * All selectors scoped to [data-dp-section] to avoid conflicts.
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════
     SLIDER
     ════════════════════════════════════════════════════════ */
  function DpSlider(sectionEl) {
    var slidesEl   = sectionEl.querySelector('[data-dp-slides]');
    var dots       = sectionEl.querySelectorAll('[data-dp-dot]');
    var thumbs     = sectionEl.querySelectorAll('[data-dp-thumb]');
    var prevBtn    = sectionEl.querySelector('[data-dp-prev]');
    var nextBtn    = sectionEl.querySelector('[data-dp-next]');

    if (!slidesEl) return;

    var total      = slidesEl.children.length;
    var current    = 0;
    var startX     = 0;
    var isDragging = false;

    function goTo(index) {
      current = (index + total) % total;
      slidesEl.style.transform = 'translateX(-' + (current * 100) + '%)';

      // Dots
      dots.forEach(function (d, i) {
        d.classList.toggle('dp-slider-dot--active', i === current);
      });

      // Thumbs
      thumbs.forEach(function (t, i) {
        t.classList.toggle('dp-thumb--active', i === current);
      });

      // Scroll thumb into view
      if (thumbs[current]) {
        thumbs[current].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-dp-dot'), 10)); });
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-dp-thumb'), 10)); });
    });

    // Touch / swipe
    slidesEl.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slidesEl.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });

    // Mouse drag
    lbInner.addEventListener('mousedown', function(e) {
        if (!isZoomed) return;

        e.preventDefault();

        dragging = true;
        startX = e.clientX - posX;
        startY = e.clientY - posY;
      });

    document.addEventListener('mouseup', function() {
        setTimeout(function() {
          dragging = false;
        }, 10);
      });

      lbInner.addEventListener('mousedown', function(e) {
  if (!isZoomed) return;

  dragging = true;
  startX = e.clientX - posX;
  startY = e.clientY - posY;
});

document.addEventListener('mousemove', function(e) {
  if (!dragging || !isZoomed) return;

  posX = e.clientX - startX;
  posY = e.clientY - startY;

  lbImg.style.transform =
    lbImg.style.transform = 'scale(' + zoomScale + ')';
});

document.addEventListener('mouseup', function() {
  dragging = false;
});
    // Expose for variant image jump
    this.goTo = goTo;
    this.getCurrent = function () { return current; };
  }

  /* ════════════════════════════════════════════════════════
     VARIANT PICKER
     ════════════════════════════════════════════════════════ */
  function dpInitVariants(sectionEl, slider) {
    var sectionId     = sectionEl.getAttribute('data-dp-section');
    var variantSelect = sectionEl.querySelector('[data-dp-variant-select]');
    if (!variantSelect) return;

    var optionInputs  = sectionEl.querySelectorAll('[data-dp-option-input]');
    var priceWrap     = sectionEl.querySelector('#dp-price-' + sectionId);
    var skuEl         = sectionEl.querySelector('[data-dp-sku]');
    var invEl         = sectionEl.querySelector('[data-dp-inventory]');
    var atcBtn        = sectionEl.querySelector('[data-dp-atc]');
    var atcText       = sectionEl.querySelector('[data-dp-atc-text]');
    var formVariantId = sectionEl.querySelector('[data-dp-variant-id]');
    var formQty       = sectionEl.querySelector('[data-dp-form-qty]');

    function getSelectedOptions() {
      var opts = {};
      optionInputs.forEach(function (input) {
        var pos = input.getAttribute('data-dp-option-input');
        if (input.type === 'radio' && input.checked) opts[pos] = input.value;
        if (input.tagName === 'SELECT') opts[pos] = input.value;
      });
      return opts;
    }

    function findMatchingVariant(selectedOpts) {
      var options = variantSelect.options;
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var match = true;
        Object.keys(selectedOpts).forEach(function (pos) {
          var key = 'data-dp-variant-option' + pos;
          if (opt.getAttribute(key) !== selectedOpts[pos]) match = false;
        });
        if (match) return opt;
      }
      return null;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active + ' ' + amount
        : amount;
    }

    function updateUI(variantOption) {
      if (!variantOption) return;

      var price       = parseInt(variantOption.getAttribute('data-dp-variant-price'), 10);
      var compare     = parseInt(variantOption.getAttribute('data-dp-variant-compare'), 10);
      var available   = variantOption.getAttribute('data-dp-variant-available') === 'true';
      var sku         = variantOption.getAttribute('data-dp-variant-sku');
      var imageId     = variantOption.getAttribute('data-dp-variant-image');
      var variantId   = variantOption.value;
      var title       = variantOption.getAttribute('data-dp-variant-title');

      // Update hidden variant select
      variantSelect.value = variantId;

      // Update form variant id
      if (formVariantId) formVariantId.value = variantId;

      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());

      // Update price
      if (priceWrap) {
        var priceHTML = '';
        if (compare && compare > price) {
          var savePct = Math.round((compare - price) / compare * 100);
          priceHTML += '<s class="dp-price dp-price--compare">' + formatMoney(compare) + '</s>';
          priceHTML += '<span class="dp-price dp-price--sale">' + formatMoney(price) + '</span>';
          priceHTML += '<span class="dp-save-badge">Save ' + savePct + '%</span>';
        } else {
          priceHTML += '<span class="dp-price">' + formatMoney(price) + '</span>';
        }
        priceWrap.innerHTML = priceHTML;
      }

      // Update SKU
      if (skuEl) skuEl.textContent = sku || 'N/A';

      // Update inventory display
      if (invEl) {
        invEl.innerHTML = available
          ? '<span class="dp-inventory__status dp-inventory__status--in">In stock</span>'
          : '<span class="dp-inventory__status dp-inventory__status--out">Out of stock</span>';
      }

      // Update ATC button
      if (atcBtn) {
        if (available) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('dp-atc-btn--sold-out');
          if (atcText) atcText.textContent = atcBtn.getAttribute('data-dp-original-label') || 'Add to Cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.classList.add('dp-atc-btn--sold-out');
          if (atcText) atcText.textContent = 'Sold Out';
        }
      }

      // Jump slider to variant image
      if (imageId && slider && slider.goTo) {
        var mediaEls = sectionEl.querySelectorAll('[data-dp-media-id]');
        mediaEls.forEach(function (el, idx) {
          if (el.getAttribute('data-dp-media-id') === imageId) {
            slider.goTo(idx);
          }
        });
      }

      // Selected value labels
      sectionEl.querySelectorAll('[data-dp-option-val]').forEach(function (labelEl) {
        var pos = labelEl.getAttribute('data-dp-option-val');
        var input = sectionEl.querySelector('[data-dp-option-input="' + pos + '"]:checked')
          || sectionEl.querySelector('select[data-dp-option-input="' + pos + '"]');
        if (input) labelEl.textContent = input.value;
      });

      // Dispatch for external integrations
      document.dispatchEvent(new CustomEvent('dp:variant:changed', {
        bubbles: true,
        detail: { variantId: variantId, title: title, available: available, price: price }
      }));
    }

    // Store original label
    if (atcBtn && atcText) {
      atcBtn.setAttribute('data-dp-original-label', atcText.textContent.trim());
    }

    // Button/swatch option interaction
    sectionEl.querySelectorAll('.dp-option-btn, .dp-swatch').forEach(function (label) {
      label.addEventListener('click', function () {
        var input = label.querySelector('input');
        if (!input) return;
        var pos = input.getAttribute('data-dp-option-input');

        // Deselect siblings
        sectionEl.querySelectorAll('[data-dp-option-input="' + pos + '"]').forEach(function (sibling) {
          var parentLabel = sibling.closest('.dp-option-btn, .dp-swatch');
          if (parentLabel) {
            parentLabel.classList.remove('dp-option-btn--selected', 'dp-swatch--selected');
          }
        });

        label.classList.add(label.classList.contains('dp-swatch') ? 'dp-swatch--selected' : 'dp-option-btn--selected');
        input.checked = true;

        var variant = findMatchingVariant(getSelectedOptions());
        updateUI(variant);
      });
    });

    // Dropdown select interaction
    sectionEl.querySelectorAll('select[data-dp-option-input]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var variant = findMatchingVariant(getSelectedOptions());
        updateUI(variant);
      });
    });
  }

  /* ════════════════════════════════════════════════════════
     QUANTITY STEPPER
     ════════════════════════════════════════════════════════ */
  function dpInitQty(sectionEl) {
    var minusBtn = sectionEl.querySelector('[data-dp-qty-minus]');
    var plusBtn  = sectionEl.querySelector('[data-dp-qty-plus]');
    var qtyInput = sectionEl.querySelector('[data-dp-qty-input]');
    var formQty  = sectionEl.querySelector('[data-dp-form-qty]');

    if (!qtyInput) return;

    function syncFormQty() {
      if (formQty) formQty.value = qtyInput.value;
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10);
        var min = parseInt(qtyInput.min, 10) || 1;
        if (val > min) {
          qtyInput.value = val - 1;
          syncFormQty();
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10);
        var max = parseInt(qtyInput.max, 10);
        if (!max || val < max) {
          qtyInput.value = val + 1;
          syncFormQty();
        }
      });
    }

    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      var min = parseInt(qtyInput.min, 10) || 1;
      if (isNaN(val) || val < min) qtyInput.value = min;
      syncFormQty();
    });
  }

  /* ════════════════════════════════════════════════════════
     ADD TO CART
     ════════════════════════════════════════════════════════ */
  function dpInitATC(sectionEl) {
    var form    = sectionEl.querySelector('[data-dp-form]');
    var atcBtn  = sectionEl.querySelector('[data-dp-atc]');
    var atcText = sectionEl.querySelector('[data-dp-atc-text]');

    if (!form || !atcBtn) return;

    var originalLabel = (atcText && atcText.textContent.trim()) || 'Add to Cart';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (atcBtn.disabled || atcBtn.classList.contains('dp-atc-btn--loading')) return;

      var variantId = sectionEl.querySelector('[data-dp-variant-id]').value;
      var qty       = parseInt(sectionEl.querySelector('[data-dp-form-qty]').value, 10) || 1;

      atcBtn.classList.add('dp-atc-btn--loading');
      if (atcText) atcText.textContent = 'Adding...';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Status ' + res.status);
          return res.json();
        })
        .then(function () {
          atcBtn.classList.remove('dp-atc-btn--loading');
          if (atcText) atcText.textContent = 'Added!';
          window.location.href = '/cart';
          return fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // Update cart count bubbles
          document.querySelectorAll([
            '[data-cart-count]', '[data-header-cart-count]',
            '.cart-count', '.cart-item-count', '.js-cart-count',
            '.header__cart-count', '.cart-count-bubble',
            '[data-cart-item-count]'
          ].join(',')).forEach(function (el) {
            el.textContent = cart.item_count;
            el.removeAttribute('hidden');
            el.style.display = '';
          });

          // Open cart drawer — try all common patterns
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }

          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));

          if (window.jQuery) {
            window.jQuery(document).trigger('cart.requestComplete', [cart]);
            window.jQuery(document.body).trigger('added.ajaxProduct');
          }

          if (window.theme && window.theme.Cart) {
            try { window.theme.Cart.open(); } catch (e) {}
          }

          if (!drawer) {
            var cartToggle = document.querySelector([
              '[data-cart-toggle]', '[data-open-cart]',
              '.js-cart-open', '.header__icon--cart',
              '[aria-controls="cart-drawer"]', '[aria-controls="CartDrawer"]'
            ].join(','));
            if (cartToggle) cartToggle.click();
          }

          // Reset label
          setTimeout(function () {
            if (atcText) atcText.textContent = originalLabel;
          }, 2500);
        })
        .catch(function (err) {
          console.error('[dp-product-section] ATC error:', err);
          atcBtn.classList.remove('dp-atc-btn--loading');
          if (atcText) atcText.textContent = 'Error — try again';
          setTimeout(function () {
            if (atcText) atcText.textContent = originalLabel;
          }, 2500);
        });
    });
  }

  /* ════════════════════════════════════════════════════════
     SHARE — copy link
     ════════════════════════════════════════════════════════ */
  function dpInitShare(sectionEl) {
    sectionEl.querySelectorAll('[data-dp-copy-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-dp-copy-url');
        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('dp-share__copy--copied');
          btn.setAttribute('aria-label', 'Link copied!');
          setTimeout(function () {
            btn.classList.remove('dp-share__copy--copied');
            btn.setAttribute('aria-label', 'Copy link');
          }, 2000);
        }).catch(function () {
          // Fallback for older browsers
          var tmp = document.createElement('textarea');
          tmp.value = url;
          tmp.style.position = 'fixed';
          tmp.style.opacity = '0';
          document.body.appendChild(tmp);
          tmp.focus();
          tmp.select();
          document.execCommand('copy');
          document.body.removeChild(tmp);
          btn.classList.add('dp-share__copy--copied');
          setTimeout(function () { btn.classList.remove('dp-share__copy--copied'); }, 2000);
        });
      });
    });
  }



  /* ════════════════════════════════════════════════════════
     SHARE POPUP (title_price_row block)
     ════════════════════════════════════════════════════════ */
  function dpInitSharePopup(sectionEl) {
    sectionEl.querySelectorAll('[data-dp-share-trigger]').forEach(function (btn) {
      var popup = btn.closest('.dp-tpr__share-wrap').querySelector('[data-dp-share-popup]');
      if (!popup) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = popup.classList.contains('dp-tpr__share-popup--open');
        // Close all other popups
        document.querySelectorAll('[data-dp-share-popup]').forEach(function (p) {
          p.classList.remove('dp-tpr__share-popup--open');
        });
        if (!isOpen) popup.classList.add('dp-tpr__share-popup--open');
      });
    });

    document.addEventListener('click', function () {
      document.querySelectorAll('[data-dp-share-popup]').forEach(function (p) {
        p.classList.remove('dp-tpr__share-popup--open');
      });
    });
  }

  /* ════════════════════════════════════════════════════════
     WISHLIST TOGGLE
     ════════════════════════════════════════════════════════ */
  // function dpInitWishlistToggle(sectionEl) {
  //   sectionEl.querySelectorAll('[data-dp-wishlist]').forEach(function (btn) {
  //     btn.addEventListener('click', function () {
  //       var active = btn.classList.toggle('dp-wishlist--active');
  //       btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  //       btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  //     });
  //   });
  // }
document.addEventListener('click', function(e){

  const btn = e.target.closest('[data-dp-wishlist]');
  if(!btn) return;

  const product = {
    id: btn.dataset.productId,
    handle: btn.dataset.productHandle,
    title: btn.dataset.productTitle,
    url: btn.dataset.productUrl,
    image: btn.dataset.productImage,
    price: btn.dataset.productPrice
  };

  let wishlist = JSON.parse(
    localStorage.getItem('wishlist') || '[]'
  );

  const exists = wishlist.findIndex(item =>
    String(item.id) === String(product.id)
  );

  if(exists > -1){
    wishlist.splice(exists, 1);
    btn.classList.remove('is-wished');
  } else {
    wishlist.push(product);
    btn.classList.add('is-wished');
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));

  window.dispatchEvent(new CustomEvent('wishlist:updated'));
});
document.addEventListener('DOMContentLoaded', function(){

  const btn = document.querySelector('[data-dp-wishlist]');
  if(!btn) return;

  const productId = btn.dataset.productId;

  const wishlist = JSON.parse(
    localStorage.getItem('wishlist') || '[]'
  );

  if(
    wishlist.some(item => String(item.id) === String(productId))
  ){
    btn.classList.add('is-wished');
  }

});
  /* ════════════════════════════════════════════════════════
     SIZE GUIDE DRAWER
     ════════════════════════════════════════════════════════ */
  function dpInitSizeGuide(sectionEl) {
    var openBtns  = sectionEl.querySelectorAll('[data-dp-size-guide-open]');
    var drawer    = sectionEl.querySelector('[data-dp-sg-drawer]');
    var overlay   = sectionEl.querySelector('[data-dp-sg-overlay]');
    var closeBtn  = sectionEl.querySelector('[data-dp-sg-close]');
    var tabs      = sectionEl.querySelectorAll('[data-dp-sg-tab]');
    var panels    = sectionEl.querySelectorAll('[data-dp-sg-panel]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('dp-sg--open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) { overlay.classList.add('dp-sg--open'); overlay.setAttribute('aria-hidden', 'false'); }
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('dp-sg--open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) { overlay.classList.remove('dp-sg--open'); overlay.setAttribute('aria-hidden', 'true'); }
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('dp-sg--open')) closeDrawer();
    });

    // Tab switching
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.getAttribute('data-dp-sg-tab'), 10);

        tabs.forEach(function (t) {
          t.classList.remove('dp-sg-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('dp-sg-panel--active');
        });

        tab.classList.add('dp-sg-tab--active');
        tab.setAttribute('aria-selected', 'true');
        var targetPanel = sectionEl.querySelector('[data-dp-sg-panel="' + idx + '"]');
        if (targetPanel) targetPanel.classList.add('dp-sg-panel--active');
      });
    });
  }

  document.addEventListener('click', function(e){

  const btn = e.target.closest('.dp-tabs__btn');
  if(!btn) return;

  const tabs = btn.closest('.dp-tabs');
  const id = btn.dataset.tab;

  tabs.querySelectorAll('.dp-tabs__btn').forEach(el=>{
    el.classList.remove('active');
  });

  tabs.querySelectorAll('.dp-tabs__panel').forEach(el=>{
    el.classList.remove('active');
  });

  btn.classList.add('active');

  tabs.querySelector('[data-panel="'+id+'"]')
      .classList.add('active');

});
  /* ════════════════════════════════════════════════════════
     BELOW CART TABS
     ════════════════════════════════════════════════════════ */
  function dpInitBelowCartTabs(sectionEl) {
    sectionEl.querySelectorAll('[data-dp-bct-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabId  = tab.getAttribute('data-dp-bct-tab');
        var groupId = tab.getAttribute('data-dp-bct-group');

        // Deactivate all tabs and panels in same group
        sectionEl.querySelectorAll('[data-dp-bct-tab][data-dp-bct-group="' + groupId + '"]').forEach(function (t) {
          t.classList.remove('dp-bct__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        sectionEl.querySelectorAll('[data-dp-bct-panel][data-dp-bct-group="' + groupId + '"]').forEach(function (p) {
          p.classList.remove('dp-bct__panel--active');
        });

        // Activate clicked tab + its panel
        tab.classList.add('dp-bct__tab--active');
        tab.setAttribute('aria-selected', 'true');
        var panel = sectionEl.querySelector('[data-dp-bct-panel="' + tabId + '"]');
        if (panel) panel.classList.add('dp-bct__panel--active');
      });
    });
  }


  /* ════════════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════════════ */
  function dpInitSection(sectionEl) {
    var sliderWrap = sectionEl.querySelector('[data-dp-slider]');
    var slider = sliderWrap ? new DpSlider(sectionEl) : null;

    dpInitVariants(sectionEl, slider);
    dpInitZoom(sectionEl);
    dpInitQty(sectionEl);
    dpInitATC(sectionEl);
    dpInitShare(sectionEl);
    dpInitSharePopup(sectionEl);
    dpInitWishlistToggle(sectionEl);
    dpInitSizeGuide(sectionEl);
    dpInitBelowCartTabs(sectionEl);
  }

  function dpInit() {
    document.querySelectorAll('[data-dp-section]').forEach(dpInitSection);
  }

  // Theme editor re-init
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target.querySelector('[data-dp-section]');
    if (sectionEl) dpInitSection(sectionEl);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dpInit);
  } else {
    dpInit();
  }

})();

document.addEventListener('change', function() {

  const variantInput = document.querySelector('input[name="id"]');
  const inventoryEl = document.querySelector('[data-dp-inventory-count]');

  if (!variantInput || !inventoryEl) return;

  const inventoryData = JSON.parse(
    document.querySelector('[data-variant-inventory]').textContent
  );

  const qty = inventoryData[variantInput.value];

  inventoryEl.textContent = qty > 0 ? qty + ' left' : '';
});
/* ════════════════════════════════════════════════════════
   IMAGE ZOOM / LIGHTBOX
   ════════════════════════════════════════════════════════ */
function dpInitZoom(sectionEl) {
  var images = sectionEl.querySelectorAll(
    '.dp-slide__img, .dp-col-item__img, .dp-stack-item__img'
  );

  if (!images.length) return;

  // Lightbox DOM (create once)
  var lightbox = document.createElement('div');
  lightbox.className = 'dp-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');

  lightbox.innerHTML = `
    <div class="dp-lightbox__inner" data-dp-lb-inner>
      <img class="dp-lightbox__img" data-dp-lb-img src="" alt="">
    </div>
    <div class="dp-lightbox__counter" data-dp-lb-counter></div>
    <button class="dp-lightbox__prev" type="button">‹</button>
    <button class="dp-lightbox__next" type="button">›</button>
    <button class="dp-lightbox__close" type="button">×</button>
  `;

  document.body.appendChild(lightbox);

  var lbImg     = lightbox.querySelector('[data-dp-lb-img]');
  var lbCounter = lightbox.querySelector('[data-dp-lb-counter]');
  var lbInner   = lightbox.querySelector('[data-dp-lb-inner]');
  var lbPrev    = lightbox.querySelector('.dp-lightbox__prev');
  var lbNext    = lightbox.querySelector('.dp-lightbox__next');
  var lbClose   = lightbox.querySelector('.dp-lightbox__close');

  var isZoomed = false;
  var posX = 0;
var posY = 0;
var startX = 0;
var startY = 0;
var dragging = false;
  var currentIdx = 0;
  var zoomScale = 2.5;

  var imgSrcs = [];
  var imgAlts = [];

  function getLargeSrc(img) {
    var srcset = img.getAttribute('srcset');
    if (!srcset) return img.src;

    var parts = srcset.split(',').map(function (s) {
      var p = s.trim().split(' ');
      return { url: p[0], size: parseInt(p[1] || 0) };
    });

    parts.sort(function (a, b) { return b.size - a.size; });
    return parts[0].url;
  }

  // Collect images + bind triggers
  images.forEach(function (img, idx) {

    imgSrcs.push(img.getAttribute('srcset') ? getLargeSrc(img) : img.src);
    imgAlts.push(img.alt || '');

    img.style.cursor = 'zoom-in';

    img.addEventListener('click', function () {
      openLightbox(idx);
    });

    // zoom icon
    var btn = document.createElement('button');
    btn.className = 'dp-zoom-trigger';
    btn.type = 'button';
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="var(--icon-stroke-width)" stroke="currentColor" class="size-6 icon icon-plus">  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"></path></svg>';

    img.parentElement.style.position = 'relative';
    img.parentElement.appendChild(btn);

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      openLightbox(idx);
    });
  });

  function openLightbox(idx) {
    currentIdx = idx;
    loadImage();
    lightbox.classList.add('dp-lightbox--open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('dp-lightbox--open');
    document.body.style.overflow = '';
  }

  function loadImage() {
      lbImg.src = imgSrcs[currentIdx];
      lbImg.alt = imgAlts[currentIdx];
      lbCounter.textContent = (currentIdx + 1) + ' / ' + images.length;

      // reset zoom every time image changes
      posX = 0;
      posY = 0;

      lbImg.style.transform =
        'translate(0px,0px) scale(1)';
      lbImg.style.transformOrigin = 'center center';
      isZoomed = false;
    }

  lbPrev.addEventListener('click', function () {
    currentIdx = (currentIdx - 1 + images.length) % images.length;
    loadImage();
  });

  lbNext.addEventListener('click', function () {
    currentIdx = (currentIdx + 1) % images.length;
    loadImage();
  });

  lbClose.addEventListener('click', closeLightbox);

  lbInner.addEventListener('mousedown', function(e) {
  if (!isZoomed) return;

      dragging = true;
      startX = e.clientX - posX;
      startY = e.clientY - posY;
    });

    document.addEventListener('mousemove', function(e) {
      if (!dragging || !isZoomed) return;

      posX = e.clientX - startX;
      posY = e.clientY - startY;

      lbImg.style.transform =
        'translate(' + posX + 'px,' + posY + 'px) scale(' + zoomScale + ')';
    });

    document.addEventListener('mouseup', function() {
      dragging = false;
    });
     lbInner.addEventListener('click', function(){

        if(isZoomed){

          lbImg.style.transform = 'scale(1)';
          lbImg.style.transformOrigin = 'center center';

          lbInner.classList.remove('dp-lightbox--zoomed');

          lbInner.scrollTop = 0;
          lbInner.scrollLeft = 0;

          isZoomed = false;

        } else {

          lbImg.style.transformOrigin = 'top center';
          lbImg.style.transform = 'scale(2.5)';

          lbInner.classList.add('dp-lightbox--zoomed');

          isZoomed = true;
        }

      });
      lbInner.addEventListener('wheel', function(e){

  if(!isZoomed) return;

  e.preventDefault();

  lbInner.scrollTop += e.deltaY;
  lbInner.scrollLeft += e.deltaX;

}, { passive:false });
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('dp-lightbox--open')) return;

    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lbPrev.click();
    if (e.key === 'ArrowRight') lbNext.click();
  });
}
